// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3Ehpj","resendInfoText":"OnGoingPaymentBox_resendInfoText__3FUG4"};